// extracted by mini-css-extract-plugin
export default {"iconContainer":"J8xVFt","leftArrowButton":"V7mLd6","icon":"mEthFr","rightArrowButton":"NKd3Cu"};